import type SVGType from 'types/svg.types';

const ConfettiIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4828 11.9883L6.29311 22.9835C5.74191 24.0611 6.84349 25.2364 7.95586 24.7576L18.8594 20.9089"
      stroke="currentColor"
      strokeWidth="1.9375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2042 14.1791C19.3223 16.623 20.2762 19.4848 19.3348 20.571C18.3934 21.6572 15.9133 20.5565 13.7952 18.1126C11.6771 15.6686 10.7232 12.8069 11.6645 11.7207C12.6059 10.6345 15.0861 11.7351 17.2042 14.1791Z"
      stroke="currentColor"
      strokeWidth="1.9375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.271 22.7807C11.5001 22.2881 10.6867 21.5799 9.92064 20.696C9.41618 20.1139 8.97775 19.5081 8.61523 18.9083"
      stroke="currentColor"
      strokeWidth="1.9375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3438 11.9479L20.51 11.7817C22.0232 10.2684 22.0232 7.81492 20.51 6.30163L20.3438 6.13542"
      stroke="currentColor"
      strokeWidth="1.9375"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M21.958 16.7918L22.3363 16.4135C22.8408 15.909 23.6586 15.909 24.163 16.4135L24.5413 16.7918"
      stroke="currentColor"
      strokeWidth="1.9375"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M13.8703 6.37647L14.3749 6.55435C15.0476 6.79153 15.4008 7.5292 15.1636 8.20198L14.9857 8.70657"
      stroke="currentColor"
      strokeWidth="1.9375"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export default ConfettiIcon;
